import moment from 'moment';

export function isFutureDate(date) {
  const today = moment(new Date()).format('MM/DD/YYYY');
  const _date = moment(date).format('MM/DD/YYYY');

  // today.setHours(23, 59, 59, 998);

  return moment(_date).isAfter(today);
}

export function isPastDate(date) {
  const today = moment(new Date()).format('MM/DD/YYYY');
  const _date = moment(date).format('MM/DD/YYYY');

  // today.setHours(23, 59, 59, 998);

  return moment(_date).isBefore(today);
}
